<template>
  <v-layout>
    <v-card class="card-box">
      <v-card-title class="subheading font-weight-bold justify-center">
        Top Traffic Pages
        <v-icon style="font-size: 18px;" class="ml-1 pointer"
          v-tooltip.top-center="{
            content: 'Top seo pages for this domain',
            trigger: $store.state.metadata.windowWidth > 600 ? 'hover' : 'click'
          }"
        >help_outline</v-icon>
      </v-card-title>
      <!-- <div class="pb-1 text-xs-center">updated: {{ powerPagesLastUpdate ? $moment(powerPagesLastUpdate).format('DD-MM-YYYY') : '-' }}</div> -->
      <v-divider></v-divider>
      <v-list dense>
        <template>
          <v-data-table
            class="table-competition"
            :headers="headerPowerPges"
            :items="powerPages.length ? powerPages.slice(0, 5) : []"
            :hide-actions="true"
            item-key="name"
          >
            <template v-slot:items="props" v-if="powerPages && powerPages.length > 0">
              <tr>
                <td>
                  <a :href="props.item.url.includes('http') ? props.item.url : 'http://' + props.item.url" target="_blank" title="props.item.from_url" class="a-readmore" v-if="props.item.url"><read-more  more-str="show full URL" :text="props.item.url" link="#" less-str="hide" :max-chars="45"></read-more></a>
                </td>
                <!-- <td class="text-xs-center">
                  <span v-if="props.item.change > 0" class="keyword-change green--text">
                    <v-icon class="green--text">arrow_drop_up</v-icon>
                    <span>+{{ props.item.change }}</span>
                  </span>
                  <span v-else-if="props.item.change < 0" class="keyword-change red--text">
                    <v-icon class="red--text">arrow_drop_down</v-icon>
                    <span>{{ Number(props.item.change.toFixed(2)) }}</span>
                  </span>
                  <span v-else>-</span>
                </td> -->
                <!-- <td class="text-xs-center">{{ props.item.count }}</td>
                <td class="text-xs-center">{{ props.item.average_rank }}</td> -->
                <td class="text-xs-center">{{ props.item.estimated }}</td>
              </tr>
            </template>
            <template slot="no-data">
              <tr>
                <td class="text-xs-center" colspan="4">
                  <span>No data available</span>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-list-tile>
          <v-list-tile-content v-if="powerPages && powerPages.length > 0" :style="{ 'align-items':'center' }">
            <a v-if="$store.state.user.email" @click="viewMorePowerPagesDialog = true">View more</a>
            <a v-else @click="$router.push({name: 'Login'})">Login to see more</a>
          </v-list-tile-content>
          <!-- <v-list-tile-content class="align-end">protein</v-list-tile-content> -->
        </v-list-tile>
      </v-list>
    </v-card>
    <PowerPagesBoxModal v-if="viewMorePowerPagesDialog" :viewMorePowerPagesDialog="viewMorePowerPagesDialog" :powerPages="powerPages"></PowerPagesBoxModal>
  </v-layout>
</template>

<script>
export default {
  name: 'PowerPagesBox',
  props: ['powerPages'],
  data () {
    return {
      loading: false,
      // testData: {'data': [{'url': 'https://www.goldmarketing.co.il/\u05d1\u05e0\u05d9\u05d9\u05ea-\u05d0\u05ea\u05e8-\u05d0\u05d9\u05e0\u05d8\u05e8\u05e0\u05d8/', 'count': 4, 'change': 0, 'average_rank': 46, 'average_page': 5}, {'url': 'https://www.goldmarketing.co.il/\u05d1\u05e0\u05d9\u05d9\u05ea-\u05d0\u05ea\u05e8\u05d9\u05dd-\u05d1\u05d5\u05d5\u05e8\u05d3\u05e4\u05e8\u05e1/', 'count': 1, 'change': 0, 'average_rank': 66, 'average_page': 7}, {'url': 'https://www.goldmarketing.co.il/seo-\u05e7\u05d9\u05d3\u05d5\u05dd-\u05d0\u05d5\u05e8\u05d2\u05e0\u05d9-\u05e7\u05d9\u05d3\u05d5\u05dd-\u05d0\u05ea\u05e8\u05d9\u05dd-\u05d1\u05d2\u05d5\u05d2\u05dc/', 'count': 1, 'change': 0, 'average_rank': 19, 'average_page': 2}, {'url': 'https://www.goldmarketing.co.il/\u05e1\u05e7\u05d9\u05e8\u05ea-\u05ea\u05d5\u05db\u05e0\u05d9\u05ea-\u05d4\u05e9\u05d5\u05ea\u05e4\u05d9\u05dd-\u05e9\u05dc-booking-com/', 'count': 1, 'change': 0, 'average_rank': 1, 'average_page': 1}, {'url': 'https://www.goldmarketing.co.il/\u05e9\u05d9\u05d5\u05d5\u05e7-\u05e9\u05d5\u05ea\u05e4\u05d9\u05dd-\u05d1\u05d5\u05e7\u05d9\u05e0\u05e7/', 'count': 1, 'change': 1, 'average_rank': 2, 'average_page': 1}], 'last_update': '2020-04-21'},
      viewMorePowerPagesDialog: false,
      powerPagesLastUpdate: '',
      headerPowerPges: [
        { text: 'Pages', value: 'url', sortable: false },
        { text: 'Estimated traffic', value: 'estimated', sortable: false, align: 'middle' }
        // { text: 'Change', value: 'change', sortable: false, align: 'middle' },
        // { text: 'Count', value: 'count', sortable: false, align: 'middle' },
        // { text: 'Average rank', value: 'average_rank', sortable: false, align: 'middle' }
      ]
    }
  },
  mounted () {
    this.$on('viewMorePowerPagesDialog', (value) => {
      this.viewMorePowerPagesDialog = value
    })
    // this.powerPages = this.testData.data
  },
  beforeDestroy () {
    this.$off('viewMorePowerPagesDialog')
  },
  methods: {
    // getLinksBox () {
    //   if (this.isAdmin || this.$store.state.user.permissions.links_box) {
    //     let params = {
    //       top: 5,
    //       engine_id: parseInt(this.$route.params.engineId)
    //     }
    //     this.loading = true
    //     this.$store.dispatch('GET_LINKS_BOX', { projectId: this.projectId, params: params }).then(res => {
    //       this.linksBoxAdditional.lastUpdate = res.last_update
    //       this.linksBoxAdditional.ignoredLinks = res.ignored_links_without_ranking
    //       this.linksBox = res.data
    //       this.loading = false
    //     }, err => {
    //       this.loading = false
    //       console.log('GET_LINKS_BOX error', err)
    //       let errorText = this.$services.getApiError(err)
    //       if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
    //     })
    //   }
    // }
  }
}
</script>

<style lang="scss">
  .card-box {
    min-height: 404px;
    width: 100%;
  }
  .table-competition .v-datatable.v-table thead tr th {
    padding: 0 5px;
  }
  .table-competition .v-datatable.v-table thead tr th:first-child {
    padding-left: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/boxes/PowerPagesBox.vue